/**
 * Local testing only: `?orbit_l4=1` turns `orbit_layer_4` on in this browser without touching the
 * tenant's config, `?orbit_l4=0` turns it back off. A production build ignores both.
 */
export const ORBIT_L4_DEV_OVERRIDE_KEY = 'orbit.layer4.devOverride';
export const ORBIT_L4_DEV_OVERRIDE_PARAM = 'orbit_l4';

export const readOrbitL4DevOverride = (search: string): boolean => {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  try {
    const param = new URLSearchParams(search).get(ORBIT_L4_DEV_OVERRIDE_PARAM);
    if (param === '1') {
      localStorage.setItem(ORBIT_L4_DEV_OVERRIDE_KEY, '1');
    } else if (param === '0') {
      localStorage.removeItem(ORBIT_L4_DEV_OVERRIDE_KEY);
    }
    return localStorage.getItem(ORBIT_L4_DEV_OVERRIDE_KEY) === '1';
  } catch (error) {
    return false;
  }
};
